import { WeekEvent } from './ComponentEvent'
import { dateToString, weekDays } from './ComponentHelpers'

class BaseEventsList {
  events: any
  date: any
  element: HTMLElement | undefined
  isExpanded: boolean
  constructor(events: any, date: any) {
    this.events = events
    this.date = date
    this.element = undefined
    this.isExpanded = false
    this.listenToElement()
  }

  toElement() {
    return `<div style="color: #000">${this.date}<div>`
  }

  listenToElement(callbac = undefined) {
    window.addEventListener(`bw-fc-event-mount-${this.date}`, (e: any) => {
      this.element = e.detail.element

      // if (callbac) {
      //   callbac()
      // }
    })
  }

  toFcEvent() {
    return {
      id: this.date,
      allDay: true,
      start: this.date,
      custom: { ...this.events },
      eventsListObj: this,
    }
  }
}

export class WeekEventsList extends BaseEventsList {
  eventObjects: any
  constructor(events: any, date: any) {
    super(events, date)
    this.eventObjects = this.events.map((event: any) => new WeekEvent(event))
    // console.log(this)

    window.addEventListener(`bw-event-popup-${this.date}`, (e) => {
      if (this.element) {
        const popup = this.element.querySelector('[data-item="events-popup"]')
        // console.log(this);

        if (popup) {
          popup.classList.remove('hidden')

          const cell = popup.closest('td')

          // console.log('probably cell', cell);

          if (cell) {
            cell.classList.add('popup-opened')
          }
        }
      }
    })

    window.addEventListener(`bw-event-popup-close-${this.date}`, (e) => {
      if (this.element) {
        const popup = this.element.querySelector('[data-item="events-popup"]')

        if (popup) {
          popup.classList.add('hidden')

          const cell = popup.closest('td')

          if (cell) {
            cell.classList.remove('popup-opened')
          }
        }
      }
    })

    // auto open all popups
    setTimeout(() => {
      if (this.element) {
        // console.log(this);
        // window.dispatchEvent(new CustomEvent(`bw-event-popup-${this.date}`))
      }
    }, 500)
  }

  toElement() {
    return `
    ${this.events
        .map(
          (event: any, index: any) =>
            `<div class="event__places ${event.type == 0 ? 'school' : 'course'}" onclick="(window.dispatchEvent(new CustomEvent('bw-event-popup-${this.date
            }')))"><div class="places__day">${new Date(this.date).getDate()}</div>
            <div class="places__item lower txt__beta spacing__reset weight__bold color__alfa lh__gamma">
            ${event.type == 0 ? `<span class="school-meeteng">${event.title} Szkoły Naturopatii</span><h3>${event.title2}</h3>` : `<h3>${event.title2}</h3>`}
            </div><div class="places__more">zobacz więcej</div>`
        )
        .join('')}
            
            </div><div class="event__popup hidden" data-item="events-popup">
            <button class="popup__close" onclick="(window.dispatchEvent(new CustomEvent('bw-event-popup-close-${this.date
      }')))"></button>
            <div class="popup__day">${new Date(this.date).getDate()}</div>
            ${this.eventObjects.map((event: any) => event.toElement()).join('')}
            </div>
            `
  }
}

// export class WeekendEventsList extends BaseEventsList {
//   constructor(events, date) {
//     super(events, date)
//     this.week = weekDays(date)

//     this.eventObjects = this.events.map((event) => new WeekendEvent(event))
//     //
//     this.listenToElement(() => {
//       window.addEventListener('bw-expand-week', (e) => {
//         const collapse = this.element.querySelector(
//           '[data-item="event-collapse"]'
//         )
//         const all = this.element.querySelector('[data-item="event-all"]')

//         if (collapse && all) {
//           if (e.detail.dates.includes(this.date)) {
//             collapse.classList.add('hidden')
//             all.classList.remove('hidden')
//             this.isExpanded = true
//           }
//         }
//       })

//       window.addEventListener('bw-expand-week-toggle', (e) => {
//         const collapse = this.element.querySelector(
//           '[data-item="event-collapse"]'
//         )
//         const all = this.element.querySelector('[data-item="event-all"]')

//         if (collapse && all) {
//           if (e.detail.dates.includes(this.date)) {
//             if (!this.isExpanded) {
//               collapse.classList.add('hidden')
//               all.classList.remove('hidden')
//               this.isExpanded = true
//             } else {
//               collapse.classList.remove('hidden')
//               all.classList.add('hidden')
//               this.isExpanded = false
//             }
//           }
//         }
//       })
//     })
//   }

//   toElement() {
//     return `<div class="event__collapse d-none" data-item="event-collapse">
//         <div class="event__places">${this.events
//         .map(
//           (event, index) =>
//             `<span class="places__item txt__beta spacing__reset weight__bold color__alfa lh__gamma">${event.place
//             }${index < this.events.length - 1 ? ',' : ''}</span>`
//         )
//         .join('')}</div>
//             <div class="event__labels">
//              ${this.events
//         .map(
//           (
//             event
//           ) => ``
//         )
//         .join('')}
//             </div>
//             <button onclick="(window.dispatchEvent(new CustomEvent('bw-expand-week-toggle', {detail: {dates: [${this.week.map(
//           (date) => `'${date}'`
//         )}]}})))" class="d-none event__see txt__beta spacing__alfa weight__regular lh__alfa color__alfa" data-item="button-see">zobacz wydarzenia: ${this.events.length
//       }</button></div>
//             <div class="event__show" data-item="event-all"> 
//             ${this.eventObjects.map((event) => event.toElement()).join('')}
//             </div>
//             `
//   }
// }
